// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0b841db","453":"18ad3da2","667":"fe161522"}[chunkId] + ".chunk.js";
};